import { Constants } from './constants'
import { Http } from './http'
import * as PhoneIntf from '@/interfaces/PhoneConfirmation'

const http = Http.create(Constants.API.Login.host)

export class PhoneConfirmationService {

	/**
	 * Start the phone confirmation process by sending 2FA token to the user
	 * @param PhoneConfirmationStartRequest
	 * @returns PhoneConfirmationStartResponse
	 */
	static async phoneConfirmationStart(request: PhoneIntf.IPhoneConfirmationStartRequest) {
		const response = await http.post<PhoneIntf.IPhoneConfirmationStartResponse>(
			`/social/phone-confirmation/start`,
			request
		)
		return response.data
	}

	/**
	 * Validate the 2FA token sent to the user
	 * @param IPhoneConfirmationValidateRequest
	 * @returns IPhoneConfirmationValidateResponse
	 */
	static async tokenValidatePhonePin(request: PhoneIntf.IPhoneConfirmationValidateRequest) {
		try {
			const response = await http.post<PhoneIntf.IPhoneConfirmationValidateResponse>(
				`/social/token/validate?type=phone-pin`,
				request
			)
			return response.data
		} catch (error: any) {
			// Handle cases where PIN code is valid and phone number is already registered in 5A
			if (error.response?.status === 409 && error.response?.data?.error === 'PhoneNumberMatched') {
				return {
					success: true
				} as PhoneIntf.IPhoneConfirmationValidateResponse
			}
			throw error
		}
	}
}
